import { useDispatch, useSelector, useStore } from "react-redux";
import type { AppDispatch, RootState, store } from "../redux/store";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import type { SerializedError } from "@reduxjs/toolkit";

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore: () => typeof store = useStore;

// type APIError = {
//   message?: string;
// };

export const getErrorMessage = (
  error: FetchBaseQueryError | SerializedError
) => {
  if (error) {
    if ("status" in error) {
      const errorData: any =
        "error" in error ? { message: error.error } : error.data;
      return errorData.message;
    } else return error.message;
  }
};
